import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

interface DetailFieldProps {
    label: ReactNode
    value: ReactNode
    fullWidth?: boolean
    colSpanClass?: string
}

export function DetailField({label, value, fullWidth, colSpanClass}: DetailFieldProps) {
    return (
        <div className={cn(colSpanClass, {'md:col-span-2': fullWidth && !colSpanClass})}>
            <dt className="text-sm font-medium text-muted-foreground">{label}</dt>
            <dd className="mt-1">
                {value === null || value === undefined || value === '' ? '—' : value}
            </dd>
        </div>
    )
}
